enum ModelTypeEnum{
    FLOW_MODEL = 'flow_model',
    DOCUMENT_MODEL = 'document_model'
}

export default ModelTypeEnum
